import { render, staticRenderFns } from "./HotDetails.vue?vue&type=template&id=16b3f09b&scoped=true&"
import script from "./HotDetails.vue?vue&type=script&lang=js&"
export * from "./HotDetails.vue?vue&type=script&lang=js&"
import style0 from "./HotDetails.vue?vue&type=style&index=0&id=16b3f09b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b3f09b",
  null
  
)

export default component.exports